var version = {
    "name":      "dativery",
    "buildDateCode": "20261104-152906",
    "buildDate": "Wed Nov 04 2026 15:29:06 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261104-152906",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;